import React, { lazy } from "react";
import { useSelector } from "react-redux";

import "./header.scss";
import ShowContainer from "../../mui/ShowContainer";
import ErrorBoundary from "../../mui/error_boundary/ErrorBoundary";
import CusSuspense from "../../mui/CusSuspense";
import HeaderAuth from "./auth/HeaderAuth";
import { Link } from "react-router-dom";
import useGetLink from "../../../hooks/other/useGetLink";

const HeaderNav = lazy(() => import("./nav/HeaderNav"));
const AsideMenu = lazy(() => import("../menu/AsideMenu"));

export default function Header() {
  const isAuth = useSelector((state) => state.user.isAuth);
  const isMenuAbsolute = useSelector((state) => state.deviceSize.isMenuAbsolute);
  const logoText = useSelector((state) => state.common.casinoName);
  const isTgBot = useSelector((state) => state.common.isTgBot);
  const isExtraSmall = useSelector((state) => state.deviceSize.isExtraSmall);
  const headerClass = isAuth ? "auth" : "no-auth";

  const linkMain = useGetLink("/");
  const isTwo = isMenuAbsolute;
  return (
    <>
      <header className={`header ${headerClass}`}>
        <ShowContainer condition={isMenuAbsolute}>
          <CusSuspense>
            <AsideMenu showLogo={isTgBot || !isExtraSmall} />
          </CusSuspense>
        </ShowContainer>
        <ShowContainer condition={!isTwo}>
          <CusSuspense fallback={<div />}>
            <HeaderNav />
          </CusSuspense>
        </ShowContainer>

        {isTgBot ? (
          <ShowContainer condition={isExtraSmall}>
            <Link draggable="false" to={linkMain}>
              <span className="header__logo__text">{logoText}</span>
            </Link>
          </ShowContainer>
        ) : (
          <ErrorBoundary>
            <HeaderAuth />
          </ErrorBoundary>
        )}
      </header>
      <ShowContainer condition={isTwo}>
        <div className="header-nav-two">
          <CusSuspense fallback={<div />}>
            <HeaderNav />
          </CusSuspense>
        </div>
      </ShowContainer>
    </>
  );
}
